import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { PublicCartId } from '../../types';
import { PublicCartSummaryResponse } from './public-cart-summary.response';
import { PublicCartShippingResponse } from './public-cart-shipping.response';
import { PublicCartShippingAddressResponse } from './public-cart-shipping-address.response';
import { PublicCartBillingAddressResponse } from './public-cart-billing-address.response';
import { Nillable } from '@web/utils';
import { PublicCartRecursiveResponse } from './public-cart-recursive.response';
import { PublicCartDiscountResponse } from './public-cart-discount.response';

@jsonObject
export class PublicCartDetailsResponse {
  @jsonMember(String)
  public readonly id!: PublicCartId;

  @jsonMember(Number)
  public readonly totalItems!: number;

  @jsonMember(PublicCartSummaryResponse)
  public readonly summary!: PublicCartSummaryResponse;

  @jsonMember(PublicCartShippingResponse)
  public readonly shipping!: PublicCartShippingResponse;

  @jsonMember(String)
  public readonly comment?: Nillable<string>;

  @jsonMember(PublicCartBillingAddressResponse)
  public readonly billingAddress!: PublicCartBillingAddressResponse;

  @jsonMember(PublicCartShippingAddressResponse)
  public readonly shippingAddress!: PublicCartShippingAddressResponse;

  @jsonMember(Boolean)
  public readonly otherShippingAddress?: Nillable<boolean>;

  @jsonMember(PublicCartDiscountResponse)
  public readonly discount?: Nillable<PublicCartDiscountResponse>;

  @jsonArrayMember(PublicCartRecursiveResponse)
  public readonly recursive?: Nillable<PublicCartRecursiveResponse[]>;
}
